import { runTransaction, getFirestore } from 'firebase/firestore'
import companyCardService from '../../services/companyCardService'
import companyService from '../../services/companyService'

class DeleteCompanyCardForm {
  onSubmit = async ({
    companyCardId,
    companyId,
  }: {
    companyCardId: string
    companyId: string
  }): Promise<void> => {
    await runTransaction(getFirestore(), async transaction => {
      const company = await companyService.fetchCompany({ companyId, transaction })
      if (company.stripePaymentMethodId === companyCardId) {
        throw new Error(
          'Something went wrong. You cannot delete an active card. You can unsubscribe instead.',
        )
      }
      await companyCardService.deleteCompanyCard({
        companyId,
        companyCardId,
      })
    })
  }
}

export default new DeleteCompanyCardForm()
